/*
 * Copyright (C) 2025 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {useScope as createI18nScope} from '@canvas/i18n'
import {IconButton} from '@instructure/ui-buttons'
import {IconAddSolid} from '@instructure/ui-icons'

const I18n = createI18nScope('block_content_editor')

export const AddButton = (props: {
  onClicked: () => void
  elementRef?: (element: Element | null) => void
}) => {
  return (
    <IconButton
      elementRef={props.elementRef}
      data-testid="add-block-button"
      data-addbutton
      data-action-button
      shape="circle"
      color="primary"
      screenReaderLabel={I18n.t('Add a block')}
      onClick={props.onClicked}
    >
      <IconAddSolid />
    </IconButton>
  )
}
